import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface Items {
  items?: Array<Items>;
  uiType?: string;
  jsonName?: string;
  Formdata?: string;
  requestType?: string;
  optional?: boolean;
  selectValues?: Array<string>;
  selectValuesDisplayText?: Array<string>;
  sampleValue?: string;
  visibleControl?: string;
  visibleIfOperator?: string;
  visibleIfValue?: string;
  displayText?: string;
}

export interface QuestionJsonElement {
  uiType?: string;
  id?: number;
  displayText?: string;
  items?: Array<Items>;
}

@Injectable()
export class QuestionJsonService {

  

  constructor(
    private httpClient : HttpClient
  ){

  }


  private result = {
    "result": [
      {
        "Formdata": [
          {
            "uiType": "page",
            "id": 1,
            "displayText": "Pers\u00F6nliche Daten",
            "items": [
              {
                "jsonName": "vorname",
                "displayText": "Vorname",
                "uiType": "text",
                "requestType": "string",
                "optional": true,
                "sampleValue": "Peter"
              },
              {
                "jsonName": "nachname",
                "displayText": "Nachname",
                "uiType": "text",
                "requestType": "string",
                "optional": true,
                "sampleValue": "Testkunde"
              },
              {
                "jsonName": "geburtsdatum",
                "displayText": "Geburtsdatum",
                "uiType": "text",
                "requestType": "string",
                "optional": false,
                "sampleValue": "01.01.1980"
              },
              {
                "jsonName": "geschlecht",
                "displayText": "Geschlecht",
                "uiType": "selectfield",
                "requestType": "integer",
                "selectValues": [
                  "1",
                  "2"
                ],
                "selectValuesDisplayText": [
                  "m\u00E4nnlich",
                  "weiblich"
                ],
                "optional": true,
                "sampleValue": "1"
              },
              {
                "jsonName": "bundesland",
                "displayText": "Bundesland",
                "uiType": "selectfield",
                "requestType": "string",
                "selectValues": [
                  "Baden-W\u00FCrttemberg",
                  "Bayern",
                  "Berlin",
                  "Brandenburg",
                  "Bremen",
                  "Hamburg",
                  "Hessen",
                  "Mecklenburg-Vorpommern",
                  "Niedersachsen",
                  "Nordrhein-Westfalen",
                  "Rheinland-Pfalz",
                  "Saarland",
                  "Sachsen",
                  "Sachsen-Anhalt",
                  "Schleswig-Holstein",
                  "Th\u00FCringen"
                ],
                "selectValuesDisplayText": [
                  "Baden-W\u00FCrttemberg",
                  "Bayern",
                  "Berlin",
                  "Brandenburg",
                  "Bremen",
                  "Hamburg",
                  "Hessen",
                  "Mecklenburg-Vorpommern",
                  "Niedersachsen",
                  "Nordrhein-Westfalen",
                  "Rheinland-Pfalz",
                  "Saarland",
                  "Sachsen",
                  "Sachsen-Anhalt",
                  "Schleswig-Holstein",
                  "Th\u00FCringen"
                ],
                "optional": false,
                "sampleValue": "Bayern"
              },
              {
                "jsonName": "berufsgruppe",
                "displayText": "Berufsgruppe",
                "uiType": "selectfield",
                "requestType": "integer",
                "selectValues": [
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8"
                ],
                "selectValuesDisplayText": [
                  "Arbeitnehmer(in)",
                  "Arbeitnehmer(in) im \u00F6D",
                  "Beamter(-in)",
                  "Selbst\u00E4ndige(r)",
                  "Arbeitslose(r)",
                  "Hausfrau \/-mann",
                  "Sch\u00FCler(in) \/ Student(in)",
                  "Rentner(in)"
                ],
                "optional": false,
                "sampleValue": "1"
              },
              {
                "jsonName": "arbeitsstaetteOst",
                "displayText": "Arbeiten Sie in den neuen Bundesl\u00E4ndern?",
                "uiType": "boolean",
                "requestType": "boolean",
                "optional": true,
                "sampleValue": "false"
              },
              {
                "jsonName": "steuerklasse",
                "displayText": "Steuerklasse",
                "uiType": "selectfield",
                "requestType": "integer",
                "selectValues": [
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
                ],
                "selectValuesDisplayText": [
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
                ],
                "optional": false,
                "sampleValue": "1"
              },
              {
                "jsonName": "kstPflicht",
                "displayText": "Kirchensteuerpflicht",
                "uiType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "true"
              },
              {
                "uiType": "row",
                "rowId": "5AE3C69B-2B7B-4FFC-A442-4CADB9D48351",
                "rowitems": [
                  {
                    "jsonName": "kinderVorhanden",
                    "displayText": "Haben Sie Kinder",
                    "uiType": "boolean",
                    "requestType": "boolean",
                    "optional": false,
                    "sampleValue": "false",
                    "visibleControl": "kinderfreibetrag",
                    "visibleIfOperator": "0",
                    "visibleIfValue": "true"
                  },
                  {
                    "jsonName": "kinderfreibetrag",
                    "displayText": "Kinderfreibetrag",
                    "uiType": "selectfield",
                    "requestType": "integer",
                    "selectValues": [
                      "0,0",
                      "0,5",
                      "1,0",
                      "1,5",
                      "2,0",
                      "2,5",
                      "3,0",
                      "3,5",
                      "4,0",
                      "4,5",
                      "5,0",
                      "5,5",
                      "6,0"
                    ],
                    "selectValuesDisplayText": [
                      "0,0",
                      "0,5",
                      "1,0",
                      "1,5",
                      "2,0",
                      "2,5",
                      "3,0",
                      "3,5",
                      "4,0",
                      "4,5",
                      "5,0",
                      "5,5",
                      "6,0"
                    ],
                    "optional": false,
                    "sampleValue": "0,0"
                  }
                ]
              }
            ]
          },
          {
            "uiType": "page",
            "id": 2,
            "displayText": "Finanzen",
            "items": [
              {
                "jsonName": "monatsbruttoentgelt",
                "displayText": "Monatsbruttoentgelt",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "3000"
              },
              {
                "uiType": "row",
                "rowId": "446D4BDA-01F7-4205-ADA8-5EBAE7A5DFFA",
                "rowitems": [
                  {
                    "jsonName": "bruttoRvPflichtig",
                    "displayText": "davon rv-pflichtig",
                    "uiType": "decimal",
                    "requestType": "decimal",
                    "optional": true,
                    "sampleValue": "3000"
                  },
                  {
                    "jsonName": "bruttoKvPflichtig",
                    "displayText": "davon kv-pflichtig",
                    "uiType": "decimal",
                    "requestType": "decimal",
                    "optional": true,
                    "sampleValue": "3000"
                  },
                  {
                    "jsonName": "bruttoSteuerPflichtig",
                    "displayText": "davon steuerpflichtig",
                    "uiType": "decimal",
                    "requestType": "decimal",
                    "optional": true,
                    "sampleValue": "3000"
                  }
                ]
              },
              {
                "jsonName": "rvPflichtig",
                "displayText": "Sind Sie rentenversicherungspflichtig?",
                "uiType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "true"
              },
              {
                "jsonName": "avPflichtig",
                "displayText": "Sind sie arbeitslosenversicherungspflichtig?",
                "uiType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "true"
              },
              {
                "jsonName": "kvArt",
                "displayText": "Wie sind Sie krankenversichert?",
                "uiType": "selectfield",
                "requestType": "integer",
                "selectValues": [
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
                ],
                "selectValuesDisplayText": [
                  "gesetzlich pflichtversichert",
                  "gesetzlich freiwillig",
                  "gesetzlich mitversichert",
                  "privatversichert mit AG-Zuschuss",
                  "privatversichert ohne AG-Zuschuss"
                ],
                "optional": false,
                "sampleValue": "false",
                "visibleControl": "zusatzbeitragGkv|beitragPkv|beitragPkvAbsetzbar",
                "visibleIfOperator": "1|2|2",
                "visibleIfValue": "4|3|3"
              },
              {
                "jsonName": "zusatzbeitragGkv",
                "displayText": "Zusatzbeitrag zur GKV",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "1,1"
              },
              {
                "jsonName": "beitragPkv",
                "displayText": "Monatsbeitrag zur PKV",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "0"
              },
              {
                "jsonName": "beitragPkvAbsetzbar",
                "displayText": "absetzbarer Anteil PKV-Beitrag",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "0"
              },
              {
                "jsonName": "monatsNettoentgelt",
                "displayText": "Monatsnettoentgelt",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "0"
              },
              {
                "jsonName": "versorgungszielEm",
                "displayText": "Versorgungsziel bei EM \/ BU",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "1650"
              }
            ]
          },
          {
            "uiType": "page",
            "id": 3,
            "displayText": "Versorgung",
            "items": [
              {
                "jsonName": "eintrittBerufsleben",
                "displayText": "Eintritt ins Berufsleben (JJJJ)",
                "uiType": "integer",
                "requestType": "integer",
                "optional": false,
                "sampleValue": "2000"
              },
              {
                "jsonName": "lueckenImVersicherungsverlauf",
                "displayText": "L\u00FCcken im Versicherungsverlauf",
                "uiType": "integer",
                "requestType": "integer",
                "optional": true,
                "sampleValue": "0"
              },
              {
                "jsonName": "anspruchGrvBekannt",
                "displayText": "Kennen Sie Ihre Anspr\u00FCche aus der GRV",
                "uiType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "false"
              },
              {
                "jsonName": "anspruchGrvEm",
                "displayText": "Anspruch bei Erwerbsminderung",
                "uiType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "0"
              }
            ]
          }
        ]
      }
    ]
  };

  // old json
  /* {
    "result":
      [
        {
          "Mask_calcVersorgung":
            [
              {
                "jsonName": "vorname",
                "displayText": "Vorname",
                "maskFieldType": "text",
                "requestType": "string",
                "optional": false,
                "sampleValue": "Peter",
                "visibleControl" : "nachname",
                "visibleIfOperator" : "0",
                "visibleIfValue" : "spezial",
                "page": 1
              }
              ,

              {
                "jsonName": "nachname",
                "displayText": "Nachname",
                "maskFieldType": "text",
                "requestType": "string",
                "optional": false,
                "sampleValue": "Testkunde",
                "page": 1
              }
              ,

              {
                "jsonName": "geburtsdatum",
                "displayText": "Geburtsdatum",
                "maskFieldType": "text",
                "requestType": "string",
                "optional": false,
                "sampleValue": "01.01.1980",
                "page": 1
              }
              ,

              {
                "jsonName": "geschlecht",
                "displayText": "Geschlecht",
                "maskFieldType": "selectfield",
                "requestType": "integer",
                "selectValues":
                  [
                    "1",
                    "2"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "männlich",
                    "weiblich"
                  ]
                ,
                "optional": true,
                "sampleValue": "1",
                "page": 1
              }
              ,

              {
                "jsonName": "bundesland",
                "displayText": "Bundesland",
                "maskFieldType": "selectfield",
                "requestType": "string",
                "selectValues":
                  [
                    "Baden-Württemberg",
                    "Bayern",
                    "Berlin",
                    "Brandenburg",
                    "Bremen",
                    "Hamburg",
                    "Hessen",
                    "Mecklenburg-Vorpommern",
                    "Niedersachsen",
                    "Nordrhein-Westfalen",
                    "Rheinland-Pfalz",
                    "Saarland",
                    "Sachsen",
                    "Sachsen-Anhalt",
                    "Schleswig-Holstein",
                    "Thüringen"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "Baden-Württemberg",
                    "Bayern",
                    "Berlin",
                    "Brandenburg",
                    "Bremen",
                    "Hamburg",
                    "Hessen",
                    "Mecklenburg-Vorpommern",
                    "Niedersachsen",
                    "Nordrhein-Westfalen",
                    "Rheinland-Pfalz",
                    "Saarland",
                    "Sachsen",
                    "Sachsen-Anhalt",
                    "Schleswig-Holstein",
                    "Thüringen"
                  ]
                ,
                "optional": false,
                "sampleValue": "Bayern",
                "page": 1
              }
              ,

              {
                "jsonName": "berufsgruppe",
                "displayText": "Berufsgruppe",
                "maskFieldType": "selectfield",
                "requestType": "integer",
                "selectValues":
                  [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "Arbeitnehmer(in)",
                    "Arbeitnehmer(in) im öD",
                    "Beamter(-in)",
                    "Selbständige(r)",
                    "Arbeitslose(r)",
                    "Hausfrau /-mann",
                    "Schüler(in) / Student(in)",
                    "Rentner(in)"
                  ]
                ,
                "optional": false,
                "sampleValue": "1",
                "page": 1
              }
              ,

              {
                "jsonName": "arbeitsstaetteOst",
                "displayText": "Arbeiten Sie in den neuen Bundesländern?",
                "maskFieldType": "boolean",
                "requestType": "boolean",
                "optional": true,
                "sampleValue": "false",
                "page": 1
              }
              ,

              {
                "jsonName": "steuerklasse",
                "displayText": "Steuerklasse",
                "maskFieldType": "selectfield",
                "requestType": "integer",
                "selectValues":
                  [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ]
                ,
                "optional": false,
                "sampleValue": "1",
                "page": 1
              }
              ,

              {
                "jsonName": "kinderVorhanden",
                "displayText": "Haben Sie Kinder",
                "maskFieldType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "false",
                "visibleControl": "kinderfreibetrag",
                "visibleIfOperator": "0",
                "visibleIfValue": "true",
                "page": 1
              }
              ,

              {
                "jsonName": "kinderfreibetrag",
                "displayText": "Kinderfreibetrag",
                "maskFieldType": "selectfield",
                "requestType": "integer",
                "selectValues":
                  [
                    "0,0",
                    "0,5",
                    "1,0",
                    "1,5",
                    "2,0",
                    "2,5",
                    "3,0",
                    "3,5",
                    "4,0",
                    "4,5",
                    "5,0",
                    "5,5",
                    "6,0"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "0,0",
                    "0,5",
                    "1,0",
                    "1,5",
                    "2,0",
                    "2,5",
                    "3,0",
                    "3,5",
                    "4,0",
                    "4,5",
                    "5,0",
                    "5,5",
                    "6,0"
                  ]
                ,
                "optional": false,
                "sampleValue": "0,0",
                "page": 1
              }
              ,

              {
                "jsonName": "kstPflicht",
                "displayText": "Kirchensteuerpflicht",
                "maskFieldType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "true",
                "page": 1
              }
              ,

              {
                "jsonName": "monatsbruttoentgelt",
                "displayText": "Monatsbruttoentgelt",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "3000",
                "page": 2
              }
              ,

              {
                "jsonName": "bruttoRvPflichtig",
                "displayText": "davon rv-pflichtig",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "3000",
                "page": 2
              }
              ,

              {
                "jsonName": "bruttoKvPflichtig",
                "displayText": "davon kv-pflichtig",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "3000",
                "page": 2
              }
              ,

              {
                "jsonName": "bruttoSteuerPflichtig",
                "displayText": "davon steuerpflichtig",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "3000",
                "page": 2
              }
              ,

              {
                "jsonName": "rvPflichtig",
                "displayText": "Sind Sie rentenversicherungspflichtig?",
                "maskFieldType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "true",
                "page": 2
              }
              ,

              {
                "jsonName": "avPflichtig",
                "displayText": "Sind sie arbeitslosenversicherungspflichtig?",
                "maskFieldType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "true",
                "page": 2
              }
              ,

              {
                "jsonName": "kvArt",
                "displayText": "Wie sind Sie krankenversichert?",
                "maskFieldType": "selectfield",
                "requestType": "integer",
                "selectValues":
                  [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "gesetzlich pflichtversichert",
                    "gesetzlich freiwillig",
                    "gesetzlich mitversichert",
                    "privatversichert mit AG-Zuschuss",
                    "privatversichert ohne AG-Zuschuss"
                  ]
                ,
                "optional": false,
                "sampleValue": "false",
                "visibleControl": "zusatzbeitragGkv|beitragPkv|beitragPkvAbsetzbar",
                "visibleIfOperator": "1|2|2",
                "visibleIfValue": "4|3|3",
                "page": 2
              }
              ,

              {
                "jsonName": "zusatzbeitragGkv",
                "displayText": "Zusatzbeitrag zur GKV",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "1,1",
                "page": 2
              }
              ,

              {
                "jsonName": "beitragPkv",
                "displayText": "Monatsbeitrag zur PKV",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "0",
                "page": 2
              }
              ,

              {
                "jsonName": "beitragPkvAbsetzbar",
                "displayText": "absetzbarer Anteil PKV-Beitrag",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "0",
                "page": 2
              }
              ,

              {
                "jsonName": "monatsNettoentgelt",
                "displayText": "Monatsnettoentgelt",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "0",
                "page": 2
              }
              ,

              {
                "jsonName": "versorgungszielEm",
                "displayText": "Versorgungsziel bei EM / BU",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "1650",
                "page": 2
              }
              ,

              {
                "jsonName": "versorgungszielAlter",
                "displayText": "Versorgungsziel im Alter",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "1800",
                "page": 2
              }
              ,

              {
                "jsonName": "kapitalbedarfUnfall",
                "displayText": "Kapitalbedarf im Falle eines Unfalls",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": false,
                "sampleValue": "350000",
                "page": 2
              }
              ,

              {
                "jsonName": "eintrittBerufsleben",
                "displayText": "Eintritt ins Berufsleben (JJJJ)",
                "maskFieldType": "integer",
                "requestType": "integer",
                "optional": false,
                "sampleValue": "2000",
                "page": 3
              }
              ,

              {
                "jsonName": "lueckenImVersicherungsverlauf",
                "displayText": "Lücken im Versicherungsverlauf",
                "maskFieldType": "integer",
                "requestType": "integer",
                "optional": true,
                "sampleValue": "0",
                "page": 3
              }
              ,

              {
                "jsonName": "lfzKrankheitsfall",
                "displayText": "Lohnfortzahlung im Krankheitsfall (in Tagen)",
                "maskFieldType": "integer",
                "requestType": "integer",
                "optional": true,
                "sampleValue": "42",
                "page": 3
              }
              ,

              {
                "jsonName": "anspruchGrvBekannt",
                "displayText": "Kennen Sie Ihre Ansprüche aus der GRV",
                "maskFieldType": "boolean",
                "requestType": "boolean",
                "optional": false,
                "sampleValue": "false",
                "page": 3
              }
              ,

              {
                "jsonName": "anspruchGrvEm",
                "displayText": "Anspruch bei Erwerbsminderung",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "0",
                "page": 3
              }
              ,

              {
                "jsonName": "anspruchGrvAv",
                "displayText": "Anspruch Altersrente",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "0",
                "page": 3
              }
              ,

              {
                "jsonName": "gewuenschterRentenbeginn",
                "displayText": "Wann möchten Sie in Rente gehen?",
                "maskFieldType": "selectfield",
                "requestType": "integer",
                "selectValues":
                  [
                    "60",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "70"
                  ]
                ,
                "selectValuesDisplayText":
                  [
                    "mit 60 Jahren",
                    "mit 61 Jahren",
                    "mit 62 Jahren",
                    "mit 63 Jahren",
                    "mit 64 Jahren",
                    "mit 65 Jahren",
                    "mit 66 Jahren",
                    "mit 67 Jahren",
                    "mit 68 Jahren",
                    "mit 69 Jahren",
                    "mit 70 Jahren"
                  ]
                ,
                "optional": false,
                "sampleValue": "65",
                "page": 3
              }
              ,

              {
                "jsonName": "restleistungsvermoegenGrv",
                "displayText": "Restleistungsvermögen bei Erwerbsminderung",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "0",
                "page": 4
              }
              ,

              {
                "jsonName": "inflationsrate",
                "displayText": "Inflationsrate",
                "maskFieldType": "decimal",
                "requestType": "decimal",
                "optional": true,
                "sampleValue": "1.5",
                "page": 4
              }
            ]
        }
      ]
  }
  */

  public getForm(){
    return this.httpClient.get(
      'https://service.versichern.online:8093/vorfinaApi/rest/TServerApi/getFormdataCapsulated'
    );
  }

  public getJson() {

    let resultData = new Promise((good, bad) => {

      window.setTimeout(() => {
        good(this.result);
      }, 1000);

    })

    return resultData;

  }
}



// WEBPACK FOOTER //
// ./src/app/services/question-json/question-json.service.ts